import Tabswitch from "../../../../layout/components/Tabswitch/Tabswitch";

function Header() {
  let tabData = [
    {
      tabName: "List",
      tabLink: "/item-categories/list",
    },
    // {
    //   tabName: "Summary",
    //   tabLink: "/items/summary",
    // },
  ];

  return (
    <>
      <Tabswitch tabData={tabData} />
    </>
  );
}

export default Header;
